package com.imobly.imobly.viewmodel

import androidx.compose.material3.SnackbarHostState
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import androidx.navigation.NavHostController
import com.imobly.imobly.api.createHttpClient
import com.imobly.imobly.api.dto.ErrorDTO
import com.imobly.imobly.api.dto.Ok
import com.imobly.imobly.api.httpclient.CategoryHttpClient
import com.imobly.imobly.api.httpclient.PropertyHttpClient
import com.imobly.imobly.api.httpclient.TenantHttpClient
import com.imobly.imobly.domain.Category
import com.imobly.imobly.domain.Property
import com.imobly.imobly.domain.Tenant
import io.github.ismoy.imagepickerkmp.domain.models.GalleryPhotoResult
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch

class CategoryViewModel(private val navController: NavHostController) : ViewModel() {

    var category = mutableStateOf(Category())

    var categories = mutableStateOf<List<Category>>(emptyList())

    var onLoadingState = mutableStateOf(false)
    val inputErrors = mutableStateOf(emptyMap<String, String>())
    val messageError = mutableStateOf("")

    var snackMessage = mutableStateOf(SnackbarHostState())

    var inputLockState = mutableStateOf(true)
    var showDialogState = mutableStateOf(false)

    val searchText: MutableState<String> = mutableStateOf("")

    fun resetPage() {
        messageError.value = ""
        category.value = Category()
        inputLockState.value = true
    }

    fun hiddenEditButton() {
        inputLockState.value = !inputLockState.value
        messageError.value = ""
    }

    fun changeShowDialog() {
        showDialogState.value = !showDialogState.value
    }

    fun changeTitle(title: String) {
        category.value = category.value.copy(title = title)
    }

    fun inputContainsError(inputLabel: String): Boolean {
        return inputErrors.value.keys.contains(inputLabel)
    }

    fun getInputErrorMessage(inputLabel: String): String {
        return inputErrors.value[inputLabel] ?: ""
    }

    fun whenStartingThePage() {
        snackMessage.value = SnackbarHostState()
        onLoadingState.value = false
    }

    fun searchAction() {
        viewModelScope.launch {
            val httpClient = CategoryHttpClient(createHttpClient())
            val list = httpClient.searchAllByTitle(searchText.value)
            categories.value = list
        }
    }


    fun createAction() {
        viewModelScope.launch {
            onLoadingState.value = true
            val httpClient = CategoryHttpClient(createHttpClient())
            val response = httpClient.create(category.value)
            onLoadingState.value = false
            when (response) {
                is Ok -> {
                    category.value = Category()
                    inputErrors.value = emptyMap()
                    messageError.value = ""
                    snackMessage.value.showSnackbar("Categoria criada com sucesso!")
                }

                is ErrorDTO -> {
                    val errors = mutableMapOf<String, String>()
                    response.errorFields?.forEach { errors[it.name] = it.description }
                    inputErrors.value = errors
                    messageError.value = response.message
                }
            }
        }
    }

    fun editAction() {
        viewModelScope.launch {
            onLoadingState.value = true
            val httpClient = CategoryHttpClient(createHttpClient())
            if (category.value.id != null) {
                val response = httpClient.update(category.value.id!!, category.value)
                onLoadingState.value = false
                when (response) {
                    is Ok -> {
                        hiddenEditButton()
                        snackMessage.value.showSnackbar("Categoria editada com sucesso!")
                    }

                    is ErrorDTO -> {
                        val errors = mutableMapOf<String, String>()
                        response.errorFields?.forEach { errors[it.name] = it.description }
                        inputErrors.value = errors
                        messageError.value = response.message
                    }
                }
            }
        }
    }

    fun deleteAction() {
        viewModelScope.launch {
            val httpClient = CategoryHttpClient(createHttpClient())
            if (category.value.id != null) {
                val response = httpClient.delete(category.value.id!!)

                showDialogState.value = false
                when (response) {
                    is Ok -> {
                        goToShowCategories()
                        snackMessage.value.showSnackbar("Categoria deletada com sucesso!")
                    }

                    is ErrorDTO -> {
                        messageError.value = response.message
                    }
                }
            }
        }
    }

    fun changeSearchText(it: String) {
        searchText.value = it
    }

    fun goToShowCategories() {
        navController.navigate("showcategories")
    }

    fun goToHome() {
        navController.navigate("home")
    }

    fun goToEditCategory(newCategory: Category) {
        category.value = newCategory
        inputLockState.value = true
        inputErrors.value = emptyMap()
        messageError.value = ""
        navController.navigate("editcategory")
    }

    fun goToCreateCategory() {
        navController.navigate("createcategory")
    }
}